
export interface Channels {
    from?: string
    from_page?: string
    channel_source?: string
    activity_type?: string
    inviter_id?: string
    invitation_code?: string
    anonymousLogin?: boolean
}

export type RegisterMethod = 'google' | 'microsoft' | 'linkedin' | 'email'
export interface LoginOptions {
    channels?: Channels
    withoutClose?: boolean
    silence?: boolean
    emailRedirectUri?: string
    onClickRegister?: (method: RegisterMethod) => void
}

interface LoginSDK {
    openLoginDialog: (options?: LoginOptions) => Promise<void>
    initSDK: () => Promise<void>
}
let loginSDKPromise: Promise<LoginSDK>;


export function getEurekaLoginSDK(): Promise<LoginSDK> {
    return loginSDKPromise ??= import(`${import.meta.env.VITE_CDN_BASE_URL}/login/login.sdk.es.no-cache.js`);
}
